import styled from "styled-components";

export const ParticleContainer = styled.div`
    position: relative;

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: none;
    }
`

export const ImageCard = styled.div`
    border: 1px solid white;
    width: 318px;
    height: 376px;
    border-radius: 1rem;
    position: relative;
    overflow: hidden;
`

export const Particle = styled.img`
    position: absolute;
    top: ${({ top }) => top};
    left: ${({ left }) => left};
    right: ${({ right }) => right};
    bottom: ${({ bottom }) => bottom};
    transform: rotate(${({ rotate }) => rotate});
`